<template>
  <TableLayout :permissions="['business:shopInfo:query']">
    <el-form ref="searchForm" slot="search-form" :model="searchForm" label-width="100px" inline>
      <el-form-item label="门店名称" prop="name">
        <el-input v-model="searchForm.name" clearable placeholder="请输入门店名称" @keypress.enter.native="search"></el-input>
      </el-form-item>
      <el-form-item label="类型" prop="companyType">
        <el-select v-model="searchForm.companyType" clearable placeholder="请选择类型" @change="search">
          <el-option label="企业" :value="1"></el-option>
          <el-option label="个人" :value="0"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="门店地址" prop="address">
        <el-input v-model="searchForm.address" clearable placeholder="请输入门店地址" @keypress.enter.native="search"></el-input>
      </el-form-item>
      <el-form-item label="联系人" prop="linkName">
        <el-input v-model="searchForm.linkName" clearable placeholder="请输入联系人" @keypress.enter.native="search"></el-input>
      </el-form-item>
      <el-form-item label="联系电话" prop="linkPhone">
        <el-input v-model="searchForm.linkPhone" clearable placeholder="请输入联系电话" @keypress.enter.native="search"></el-input>
      </el-form-item>
      <el-form-item label="提交时间" prop="createTime">
        <el-date-picker type="daterange" v-model="searchForm.createTime1" clearable value-format="yyyy-MM-dd HH:mm:ss"
                        range-separator="-" start-placeholder="开始日期" end-placeholder="结束日期" @change="handleDateChange" />
      </el-form-item>
      <el-form-item label="状态" prop="auditStatus">
        <el-select v-model="searchForm.auditStatus" clearable placeholder="请选择状态" @change="search">
          <el-option label="待审批" :value="0"></el-option>
          <el-option label="审批通过" :value="1"></el-option>
          <el-option label="审批未通过" :value="2"></el-option>
          <el-option label="已支付押金" :value="3"></el-option>
        </el-select>
      </el-form-item>
      <section>
        <el-button type="primary" @click="search">搜索</el-button>
        <el-button @click="reset">重置</el-button>
      </section>
    </el-form>
    <template v-slot:table-wrap>
      <el-table
          :height="tableHeightNew"
        v-loading="isWorking.search"
        :data="tableData.list"
        stripe
        @selection-change="handleSelectionChange"
      >
        <el-table-column type="selection" width="55"></el-table-column>
        <el-table-column prop="name" label="门店名称" min-width="120px">
          <template slot-scope="{row}">
            <span class="link-name" @click="openShopInfo(row)">{{ row.name }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="companyType" label="类型" min-width="80px">
          <template slot-scope="{row}">
            {{row.companyType == 1 ? '企业' : '个人'}}
          </template>
        </el-table-column>
        <el-table-column prop="address" label="门店地址" min-width="200px"></el-table-column>
        <el-table-column prop="linkName" label="联系人" min-width="100px"></el-table-column>
        <el-table-column prop="linkPhone" label="联系电话" min-width="120px"></el-table-column>
        <el-table-column prop="createTime" label="提交日期" min-width="160px"></el-table-column>
        <el-table-column label="审批状态" min-width="100px">
          <template slot-scope="{row}">
            <span style="color: #FFA500;" v-if="row.auditStatus == 0">待审批</span>
            <span style="color: #13ce66;" v-else-if="row.auditStatus == 1">审批通过</span>
            <span style="color: #ff4949;" v-else-if="row.auditStatus == 2">审批未通过</span>
            <span style="color: grey;" v-else-if="row.auditStatus == 3">已支付押金</span>
          </template>
        </el-table-column>
        <el-table-column label="操作" min-width="150" fixed="right">
          <template slot-scope="{row}">
            <el-button type="text" v-if="row.auditStatus == 0" @click="handleAudit(row)">审核</el-button>
          </template>
        </el-table-column>
      </el-table>
      <pagination
        @size-change="handleSizeChange"
        @current-change="handlePageChange"
        :pagination="tableData.pagination"
      >
      </pagination>
    </template>
    <!-- 门店详情 -->
    <OperaShopInfoSeeWindow ref="operaShopInfoSeeWindow" />
    <OperaShopApprovalWindow ref="operaShopApprovalWindow" @success="search" />
  </TableLayout>
</template>

<script>
import BaseTable from '@/components/base/BaseTable'
import TableLayout from '@/layouts/TableLayout'
import Pagination from '@/components/common/Pagination'
import OperaShopInfoSeeWindow from '@/components/business/OperaShopInfoSeeWindow'
import OperaShopApprovalWindow from '@/components/business/OperaShopApprovalWindow'

export default {
  name: 'ShopQualificationList',
  extends: BaseTable,
  components: { TableLayout, Pagination, OperaShopInfoSeeWindow, OperaShopApprovalWindow },
  data () {
    return {
      searchForm: {
        name: '',
        companyType: '',
        address: '',
        linkName: '',
        linkPhone: '',
        createTime1: '',
        createStartTime: '',
        createEndTime: ''
        // auditStatusList: [0,1,2]
      }
    }
  },
  created () {
    this.config({
      module: '门店列表',
      api: '/business/shopInfo',
      'field.id': 'id',
      'field.main': 'id'
    })
    this.search()
  },
  methods: {
    reset () {
      this.searchForm = {
        name: '',
        companyType: '',
        address: '',
        linkName: '',
        linkPhone: '',
        createTime1: '',
        status: ''
      }
      this.search()
    },
    handleDateChange (val) {
      this.searchForm.createStartTime = val ? val[0] : ''
      this.searchForm.createEndTime = val ? val[1] : ''
      this.search()
    },
    handleAudit (row) {
      this.$refs.operaShopApprovalWindow.open('门店审批（'+row.name+'）', row)
    },
    openShopInfo (row) {
      this.$refs.operaShopInfoSeeWindow.open('门店审批（'+row.name+'）', row)
    }
  }
}
</script>
<style scoped>
.link-name {
  color: #2E68EC;
  text-decoration: underline;
  cursor: pointer;
}
</style>
